import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    instruccionesCobros: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.instruccionesCobros = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.cliente = null;
    },

    'INICIALIZAR_INSTRUCCIONES_COBROS' (state) {
        state.instruccionesCobros = [];
    },
    'SET_INSTRUCCIONES_COBROS' (state, instruccionesCobros) {
        state.instruccionesCobros = instruccionesCobros;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getInstruccionesCobros ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INSTRUCCIONES_COBROS');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += '&clienteId=' + state.cliente.id;
                }
            }
            
            apiAxios.get('instrucciones-cobros' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_INSTRUCCIONES_COBROS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( { }, cobroId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`instrucciones-cobros/${cobroId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}